// src/components/products/ProductForm/GeneralInfoSections/PricingOperationsSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";
// import DateInput from "../../../inputs/DateInput";

const PricingOperationsSection = ({
    formData,
    setFormData,
    errors,
    isArabic,
    activeLang,
    handleMultiLangChange,
    handlePricingUnitChange,
    pricingUnitsOptions,
    loadingPricingUnits,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Pricing Unit */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'وحدة التسعير' : 'Pricing Unit'}
                    type="select"
                    name="pricing_unit_id"
                    value={formData.pricing_unit_id || ''}
                    onChange={handlePricingUnitChange}
                    required
                    disabled={loadingPricingUnits}
                    error={!!errors.pricing_unit_id}
                    helperText={errors.pricing_unit_id}
                    options={pricingUnitsOptions}
                />
            </Grid>

            {/* Locations */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="الموقع (عربي)"
                        type="text"
                        name="locations_ar"
                        value={formData.locations?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange('locations', 'ar', e.target.value)
                        }
                        required={false}
                        error={!!errors.locations_ar}
                        helperText={errors.locations_ar}
                    />
                </Grid>
            )}

            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Locations (English)"
                        type="text"
                        name="locations_en"
                        value={formData.locations?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange('locations', 'en', e.target.value)
                        }
                        required={false}
                        error={!!errors.locations_en}
                        helperText={errors.locations_en}
                    />
                </Grid>
            )}

            {/* Rate Availability Start Date */}
            <Grid item xs={12} md={6}>
                {/* <DateInput
                    label={isArabic ? 'الوقت المتوفر يبدأ من' : 'Rate Availability Start Date'}
                    value={formData.rate_availability_start_date || ''}
                    onChange={(e) =>
                        setFormData({
                            ...formData,
                            rate_availability_start_date: e.target.value
                        })
                    }
                    required={false}
                    disablePast={true}
                    error={!!errors.rate_availability_start_date}
                    helperText={errors.rate_availability_start_date}
                /> */}
                <FormInput
                    label={isArabic ? 'الوقت المتوفر يبدأ من' : 'Rate Availability Start Date'}
                    type="date"
                    name="req_date"
                    value={formData.rate_availability_start_date || ''}
                    onChange={(e) =>
                        setFormData({
                            ...formData,
                            rate_availability_start_date: e.target.value
                        })
                    }
                    disablePast={true}
                    error={!!errors.rate_availability_start_date}
                    helperText={errors.rate_availability_start_date}
                />
            </Grid>

            {/* Rate Availability End Date */}
            <Grid item xs={12} md={6}>
                {/* <DateInput
                    label={isArabic ? 'الوقت المتوفر ينتهي ف' : 'Rate Availability End Date'}
                    value={formData.rate_availability_end_date || ''}
                    onChange={(e) =>
                        setFormData({
                            ...formData,
                            rate_availability_end_date: e.target.value
                        })
                    }
                    required={false}
                    disablePast={true}
                    min={formData.rate_availability_start_date
                        ? (() => {
                            const startDate = new Date(formData.rate_availability_start_date);
                            startDate.setDate(startDate.getDate() + 1);
                            return startDate.toISOString().split('T')[0];
                        })()
                        : ''
                    }
                    error={!!errors.rate_availability_end_date}
                    helperText={errors.rate_availability_end_date}
                /> */}
                <FormInput
                    type="date"
                    label={isArabic ? 'الوقت المتوفر ينتهي ف' : 'Rate Availability End Date'}
                    value={formData.rate_availability_end_date || ''}
                    onChange={(e) =>
                        setFormData({
                            ...formData,
                            rate_availability_end_date: e.target.value
                        })
                    }
                    required={false}
                    disablePast={true}
                    min={formData.rate_availability_start_date
                        ? (() => {
                            const startDate = new Date(formData.rate_availability_start_date);
                            startDate.setDate(startDate.getDate() + 1);
                            return startDate.toISOString().split('T')[0];
                        })()
                        : ''
                    }
                    error={!!errors.rate_availability_end_date}
                    helperText={errors.rate_availability_end_date}
                />
            </Grid>

            {/* Operating Days */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="أيام التشغيل (عربي)"
                        type="text"
                        name="operating_days_ar"
                        value={formData.operating_days?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange('operating_days', 'ar', e.target.value)
                        }
                        placeholder="مثال: السبت - الخميس"
                        required={false}
                        error={!!errors.operating_days_ar}
                        helperText={errors.operating_days_ar}
                    />
                </Grid>
            )}

            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Operating Days (English)"
                        type="text"
                        name="operating_days_en"
                        value={formData.operating_days?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange('operating_days', 'en', e.target.value)
                        }
                        placeholder="Example: Saturday - Thursday"
                        required={false}
                        error={!!errors.operating_days_en}
                        helperText={errors.operating_days_en}
                    />
                </Grid>
            )}

            {/* Operating Type */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="نوع التشغيل (عربي)"
                        type="text"
                        name="operating_type_ar"
                        value={formData.operating_type?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange('operating_type', 'ar', e.target.value)
                        }
                        placeholder="مثال: يومي"
                        required={false}
                        error={!!errors.operating_type_ar}
                        helperText={errors.operating_type_ar}
                    />
                </Grid>
            )}

            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Operating Type (English)"
                        type="text"
                        name="operating_type_en"
                        value={formData.operating_type?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange('operating_type', 'en', e.target.value)
                        }
                        placeholder="Example: Daily"
                        required={false}
                        error={!!errors.operating_type_en}
                        helperText={errors.operating_type_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default PricingOperationsSection;
